import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-column-gap: 40px;
  ${props => props.theme.container}
  margin: 0 auto;
  padding: 150px 0 200px 0;
  position: relative;

  ${props => props.theme.bp.sm`
    grid-template-columns: 1fr;
    padding-top: 50px;
    padding-bottom: 100px;
  `}
`;

export const H1 = styled.h1`
  color: ${props => props.theme.colors.normalText};
  text-align: left;
  font-size: 7rem;
  line-height: 7rem;
  padding-left: 80px;
  ${props => props.theme.bp.sm`
    padding: 0 40px;
  `}
`;

export const P = styled.p`
  text-align: justify;
  padding-right: 80px;
  ${props => props.theme.bp.sm`
    padding: 20px 40px 20px;
  `}

  span {
    padding-top: 15px;
    display: block;
    color: ${props => props.theme.colors.normalText};
    font-style: italic;
  }
`;
